<template>
  <v-container fluid class="admin-page">
      <v-row class="justify-space-between">
        <v-col
        cols="7"
        >
            <h2>{{ formType.text }} Sample</h2>
        </v-col>
        <v-col cols="2" class="text-center">
            <v-btn type="submit" class="text--futura text--white" dark block @click.prevent="saveSample()" :loading="buttonLoading" :disabled="buttonLoading">
                {{ formType.value == 'new' ? 'Save' : 'Update' }}
                <template v-slot:loader>
                    <v-progress-circular
                        indeterminate
                        color="black"
                    ></v-progress-circular>
                </template>
            </v-btn>
        </v-col>
      </v-row>
      <Alert />
      <v-container class="crystal-admin-form">
        <v-row class="justify-space-around">
                <v-col cols="5">
                    <label>Recipient Type: </label>
                    <v-select
                        solo
                        placeholder="Recipient Type"
                        v-model="recipient_type"
                        :items="recipient_types"
                    >
                    </v-select>
                    <label>Recipient Name: </label>
                    <v-autocomplete
                        solo
                        placeholder="Search Recipient"
                        v-model="recipient"
                        :items="customerOptions"
                        item-text="displayName"
                        :loading="customerSearchLoading"
                        :search-input.sync="customerSearch"
                        :no-data-text="customerSearch ? 'No matching customers found' : 'Type at least 2 characters to search'"
                        no-filter
                        clearable
                        return-object
                        v-if="recipient_type == 'customer' || recipient_type == ''"
                    >
                    </v-autocomplete>
                    <v-autocomplete
                        solo
                        placeholder="Search Recipient"
                        v-model="recipient"
                        :items="vendorOptions"
                        v-else-if="recipient_type == 'vendor'"
                        item-text="displayName"
                        :loading="vendorSearchLoading"
                        :search-input.sync="vendorSearch"
                        :no-data-text="vendorSearch ? 'No matching vendors found' : 'Type at least 2 characters to search'"
                        no-filter
                        clearable
                        return-object
                    >
                    </v-autocomplete>
                    <label>Customer Contact</label>
                    <v-text-field
                        solo
                        placeholder="Enter Recipient Phone Number"
                        prefix="+62 |"
                        v-model="phone_number"
                    ></v-text-field>
                    <label>Shipment Address: </label>
                    <v-textarea
                        solo
                        placeholder="Shipment Address"
                        v-model="sample.ShiptoAddress1"
                    ></v-textarea>
                    <label>Shipment Province: </label>
                    <v-autocomplete
                        solo
                        placeholder="Shipment Province"
                        v-model="sample.province_id"
                        :items="provinces"
                        item-text="name"
                        item-value="province_id"
                    ></v-autocomplete>
                    <div
                        v-if="sample.province_id"
                    >
                        <label>Shipment City: </label>
                        <v-autocomplete
                            solo
                            placeholder="Shipment City"
                            v-model="sample.city_id"
                            :items="cities"
                            item-text="name"
                            item-value="city_id"
                        >
                            <template slot="selection" slot-scope="data">
                                <!-- HTML that describe how select should render selected items -->
                                {{ data.item.type }} {{ data.item.name }}
                            </template>
                            <template slot="item" slot-scope="data">
                                <!-- HTML that describe how select should render items when the select is open -->
                                {{ data.item.type }} {{ data.item.name }}
                            </template>
                        </v-autocomplete>
                    </div>
                    <label>Postal Code:</label>
                    <v-text-field
                        solo
                        placeholder="Enter Postal Code"
                        v-model="sample.postal_code"
                    >
                    </v-text-field>
                    <label>Shipment Status: </label>
                    <v-select
                        solo
                        :items="shipment_statuses"
                        item-text="label" 
                        item-value="value"
                        label="Choose Status"
                        v-model="sample.ShipStatus"
                    ></v-select>
                    <!-- <label>Courier Tracking Code: </label>
                    <v-text-field
                        solo
                        placeholder="Courier Tracking Code"
                    ></v-text-field> -->
                </v-col>
                <v-col cols="5">
                    <label>Ship From</label>
                    <v-autocomplete
                        solo
                        :items="warehouses"
                        placeholder="Warehouse Location"
                        append-icon="mdi-magnify"
                        item-text="LocationName"
                        item-value="id"
                        v-model="sample.ShipFromLocationId"
                    >    
                    </v-autocomplete>
                    <label>Shipment Date: </label>
                    <v-row>
                        <v-col
                        cols="12"
                        >
                            <v-menu
                                ref="menu2"
                                v-model="menu2"
                                :close-on-content-click="false"
                                :return-value.sync="shipment_date"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="shipment_date"
                                    label="Shipment Date"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    solo
                                    append-icon="mdi-calendar"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="shipment_date"
                                no-title
                                scrollable
                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="menu2 = false"
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu2.save(shipment_date)"
                                >
                                    OK
                                </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <label>Purpose:</label>
                    <v-select
                        :items="purposes"
                        solo
                        label="Choose Purpose"
                        v-model="sample.purpose"
                    >
                    </v-select>
                    <label>Courier:</label>
                    <v-select
                        solo
                        :items="couriers"
                        item-text="CourierCompany"
                        item-value="id"
                        v-model="sample.DeliveryMethodId"
                        label="Choose Couriers"
                    >
                    </v-select>
                    <label>Memo:</label>
                    <v-text-field
                        solo
                        placeholder="Enter Memo"
                        v-model="sample.memo"
                    >
                    </v-text-field>
                </v-col>
        </v-row>
        <hr>
        <v-container>
            <ProductOrder
                v-for="(product, index) in sample.SampleLine.items"
                :key="product.id"
                :index="index"
                :product="product"
                @deleteProduct="deleteProduct"
                @updateProduct="updateProduct"
                type="sample"
            />
        </v-container>
        <v-row class="justify-center">
            <v-col cols="2">
                <v-btn type="submit" class="text--futura text--white" dark block @click.prevent="addProduct()">
                    + Add Product
                </v-btn>
            </v-col>
        </v-row>
        <hr>
        <v-row class="flex-column align-end">
            <v-col cols="4">
                <span>Total Quantity : {{ quantity }}</span>
            </v-col>
        </v-row>
      </v-container>
      <v-row class="justify-end">
          <v-col cols="2">
              <v-btn type="submit" class="text--futura text--white" dark block @click.prevent="saveSample()" :loading="buttonLoading" :disabled="buttonLoading">
                {{ formType.value == 'new' ? 'Save' : 'Update' }}
                <template v-slot:loader>
                    <v-progress-circular
                        indeterminate
                        color="black"
                    ></v-progress-circular>
                </template>
              </v-btn>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
import Alert from '@/components/Alert.vue';
import ProductOrder from '@/components/ProductOrder.vue';
import server from '@/api';

export default {
    name: 'SampleForm',
    components: {
        Alert,
        ProductOrder,
    },
    props: {
        sample: {
            type: Object,
            default: () => {
                return {
                    DeliveryMethodId: 1,
                    ShipStatus: '',
                    province_id: '',
                    city_id: '',
                    ShiptoAddress1: '',
                    purpose: '',
                    ShipFromLocationId: '',
                    SampleLine: {
                        items: []
                    },
                    shipment_date: '',
                    memo: ''
                }
            }
        },
        formType: {
            type: Object,
            default: () => {
                return {
                    text: 'Add New',
                    value: 'new'
                }
            }
        },
        buttonLoading: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            menu: false,
            menu2: false,
            taxes: [
                { text: '5 %', value: 5},
                { text: '10 %', value: 10},
                { text: '20 %', value: 20},
                { text: '30 %', value: 30}
            ],
            dropshipper_check: true,
            recipient_types: [
                {
                    text: 'Customer',
                    value: 'customer'
                },
                {
                    text: 'Vendor',
                    value: 'vendor'
                }
            ],
            selectedTax: 10,
            delivery_fee: 0,
            recipientType: '',
            recipientObj: null,
            customerOptions: [],
            vendorOptions: [],
            customerSearch: '',
            vendorSearch: '',
            customerSearchLoading: false,
            vendorSearchLoading: false,
            customerSearchTimeout: null,
            vendorSearchTimeout: null,
            customerSearchRequestId: 0,
            vendorSearchRequestId: 0,
            syncingInitialRecipient: false
        }
    },
    methods: {
        saveSample () {
            this.$emit('saveSample', this.recipient);
        },
        addProduct () {
            let newProduct = {
                ItemId: '',
                qty: '',
                Item: {
                    name: ''
                }
            }
            this.sample.SampleLine.items.push(newProduct);
        },
        deleteProduct(index) {
            this.sample.SampleLine.items.splice(index, 1);
        },
        updateProduct (index, id, qty, price) {
            this.sample.SampleLine.items[index].ItemId = id;
            this.sample.SampleLine.items[index].qty = qty;
            this.sample.SampleLine.items[index].price = price;
        },
        normalizeSearch(value) {
            return String(value || '').trim();
        },
        normalizeComparableValue(value) {
            return this.normalizeSearch(value).toLowerCase();
        },
        getRecipientSortScore(item = {}, normalizedSearch = '') {
            const displayName = this.normalizeComparableValue(item.displayName);
            const companyName = this.normalizeComparableValue(item.company_name);
            const fullName = this.normalizeComparableValue([
                item.firstName || item.first_name,
                item.middleName || item.middle_name,
                item.lastName || item.last_name
            ].filter(Boolean).join(' '));
            const phoneNumber = this.normalizeComparableValue(
                item.CustomerContact?.contactNo || item.VendorContact?.phone_number
            ).replace(/[\s-]/g, '');
            const searchPhone = normalizedSearch.replace(/[\s-]/g, '');
            const haystacks = [displayName, companyName, fullName];

            if (!normalizedSearch) return 99;
            if (haystacks.some(value => value === normalizedSearch) || phoneNumber === searchPhone) return 0;
            if (haystacks.some(value => value.startsWith(normalizedSearch)) || phoneNumber.startsWith(searchPhone)) return 1;
            if (haystacks.some(value => value.includes(normalizedSearch)) || phoneNumber.includes(searchPhone)) return 2;

            return 3;
        },
        sortRecipientOptions(items = [], search = '') {
            const normalizedSearch = this.normalizeComparableValue(search);

            return [...items].sort((left, right) => {
                const scoreDiff = this.getRecipientSortScore(left, normalizedSearch) - this.getRecipientSortScore(right, normalizedSearch);

                if (scoreDiff !== 0) return scoreDiff;

                return String(left.displayName || '').localeCompare(String(right.displayName || ''), undefined, {
                    numeric: true,
                    sensitivity: 'base'
                });
            });
        },
        mergeRecipientOptions(items = [], selectedItem = null, search = '') {
            const optionMap = new Map();
            const normalizedSearch = this.normalizeComparableValue(search);
            const shouldIncludeSelectedItem = selectedItem &&
                selectedItem.id &&
                (!normalizedSearch || this.getRecipientSortScore(selectedItem, normalizedSearch) < 3);

            [...items, shouldIncludeSelectedItem ? selectedItem : null].filter(item => item && item.id).forEach((item) => {
                optionMap.set(item.id, item);
            });

            return this.sortRecipientOptions(Array.from(optionMap.values()), search);
        },
        formatCustomerOption(customer) {
            if (!customer) return null;

            const customerContact = customer.CustomerContact ||
                (Array.isArray(customer.CustomerContacts) ? customer.CustomerContacts[0] : null) ||
                null;
            const displayName = customer.fullName ||
                [customer.firstName, customer.middleName, customer.lastName].filter(Boolean).join(' ').trim() ||
                customer.company_name ||
                `Customer #${customer.id}`;

            return {
                ...customer,
                CustomerContact: customerContact,
                displayName
            };
        },
        formatVendorOption(vendor) {
            if (!vendor) return null;

            const displayName = vendor.company_name ||
                [vendor.first_name, vendor.middle_name, vendor.last_name].filter(Boolean).join(' ').trim() ||
                `Vendor #${vendor.id}`;

            return {
                ...vendor,
                VendorContact: vendor.VendorContact || null,
                displayName
            };
        },
        setCustomerOptions(customers = []) {
            const formattedCustomers = customers
                .map(customer => this.formatCustomerOption(customer))
                .filter(Boolean);
            const selectedCustomer = this.recipient_type === 'customer' ? this.formatCustomerOption(this.recipient) : null;

            this.customerOptions = this.mergeRecipientOptions(formattedCustomers, selectedCustomer, this.customerSearch);
        },
        setVendorOptions(vendors = []) {
            const formattedVendors = vendors
                .map(vendor => this.formatVendorOption(vendor))
                .filter(Boolean);
            const selectedVendor = this.recipient_type === 'vendor' ? this.formatVendorOption(this.recipient) : null;

            this.vendorOptions = this.mergeRecipientOptions(formattedVendors, selectedVendor, this.vendorSearch);
        },
        syncInitialRecipient() {
            if (this.recipientType && this.recipientObj && this.recipientObj.id) return;

            if (this.sample && this.sample.Customer) {
                this.syncingInitialRecipient = true;
                this.recipientType = 'customer';
                this.recipientObj = this.formatCustomerOption(this.sample.Customer);
                this.setCustomerOptions([]);
                this.syncingInitialRecipient = false;
                return;
            }

            if (this.sample && this.sample.Vendor) {
                this.syncingInitialRecipient = true;
                this.recipientType = 'vendor';
                this.recipientObj = this.formatVendorOption(this.sample.Vendor);
                this.setVendorOptions([]);
                this.syncingInitialRecipient = false;
            }
        },
        resetRecipientSearchState() {
            this.recipientObj = null;
            this.customerSearch = '';
            this.vendorSearch = '';
            this.customerOptions = [];
            this.vendorOptions = [];
            this.customerSearchLoading = false;
            this.vendorSearchLoading = false;
        },
        scheduleCustomerSearch(value) {
            if (this.customerSearchTimeout) {
                clearTimeout(this.customerSearchTimeout);
            }

            const normalizedSearch = this.normalizeSearch(value);

            if (normalizedSearch.length < 2) {
                this.customerSearchLoading = false;
                this.setCustomerOptions([]);
                return;
            }

            this.customerSearchLoading = true;
            this.customerSearchTimeout = setTimeout(() => {
                this.fetchCustomerOptions(normalizedSearch);
            }, 350);
        },
        scheduleVendorSearch(value) {
            if (this.vendorSearchTimeout) {
                clearTimeout(this.vendorSearchTimeout);
            }

            const normalizedSearch = this.normalizeSearch(value);

            if (normalizedSearch.length < 2) {
                this.vendorSearchLoading = false;
                this.setVendorOptions([]);
                return;
            }

            this.vendorSearchLoading = true;
            this.vendorSearchTimeout = setTimeout(() => {
                this.fetchVendorOptions(normalizedSearch);
            }, 350);
        },
        async fetchCustomerOptions(search) {
            const requestId = ++this.customerSearchRequestId;

            try {
                const { data } = await server.get('/customers/search/lite', {
                    params: {
                        search,
                        limit: 20
                    },
                    headers: {
                        token: localStorage.token
                    }
                });

                if (requestId !== this.customerSearchRequestId) return;
                this.setCustomerOptions(data.Customers || []);
            } catch (error) {
                if (requestId !== this.customerSearchRequestId) return;
                this.setCustomerOptions([]);
            } finally {
                if (requestId === this.customerSearchRequestId) {
                    this.customerSearchLoading = false;
                }
            }
        },
        async fetchVendorOptions(search) {
            const requestId = ++this.vendorSearchRequestId;

            try {
                const { data } = await server.get('/vendors/search/lite', {
                    params: {
                        search,
                        limit: 20
                    },
                    headers: {
                        token: localStorage.token
                    }
                });

                if (requestId !== this.vendorSearchRequestId) return;
                this.setVendorOptions(data.Vendors || []);
            } catch (error) {
                if (requestId !== this.vendorSearchRequestId) return;
                this.setVendorOptions([]);
            } finally {
                if (requestId === this.vendorSearchRequestId) {
                    this.vendorSearchLoading = false;
                }
            }
        }
    },
    watch: {
        sample: {
            immediate: true,
            handler() {
                this.syncInitialRecipient();
            }
        },
        recipientType(newValue, oldValue) {
            if (this.syncingInitialRecipient || !oldValue || newValue === oldValue) return;
            this.resetRecipientSearchState();
        },
        customerSearch(value) {
            if (this.recipient_type !== 'customer' && this.recipient_type !== '') return;
            this.scheduleCustomerSearch(value);
        },
        vendorSearch(value) {
            if (this.recipient_type !== 'vendor') return;
            this.scheduleVendorSearch(value);
        }
    },
    computed: {
        quantity () {
            let quantity = 0;
            for(let i = 0; i < this.sample.SampleLine.items.length; i++) {
                quantity += +this.sample.SampleLine.items[i].qty;
            }
            return quantity;
        },
        provinces () {
            return this.$store.state.provinces;
        },
        cities () {
            let province_id = this.sample.province_id;
            return this.$store.state.cities.filter(city => city.province_id == province_id)
        },
        couriers () {
            return this.$store.state.couriers;
        },
        warehouses () {
            return this.$store.state.warehouses;
        },
        purposes () {
            return this.$store.state.purposes;
        },
        shipment_statuses () {
            return this.$store.state.shipment_statuses;
        },
        recipient: {
            get: function () {
                if (this.recipientType) {
                    return this.recipientObj
                } else if (this.sample.Customer) {
                    return this.formatCustomerOption(this.sample.Customer)
                } else if (this.sample.Vendor) {
                   return this.formatVendorOption(this.sample.Vendor)
                } else {
                    return this.recipientObj
                }
            },
            set: function (value) {
                this.recipientObj = value;
            }
        },
        recipient_type: {
            get: function () {
                if (this.recipientType) {
                    return this.recipientType
                } else if (this.sample.Customer) {
                    return 'customer'
                } else if (this.sample.Vendor) {
                    return 'vendor'
                } else {
                    return this.recipientType
                }
            },
            set: function (value) {
                this.recipientType = value;
            }
        },
        phone_number: {
            get: function () {
                if(this.recipient && this.recipient.CustomerContact) {
                    return this.removeCountryCode(this.recipient.CustomerContact.contactNo);
                } else if(this.recipient && this.recipient.VendorContact) {
                    return this.removeCountryCode(this.recipient.VendorContact.phone_number);
                } else {
                    return ''
                }
            },
        },
        shipment_date: {
            get: function () {
                return this.sample.shipment_date ? this.formatDate(this.sample.shipment_date, 'YYYY-MM-DD') : ''
            },
            set: function (value) {
                this.sample.shipment_date = value
            }
        }
    },
    created () {
        this.syncInitialRecipient()
        this.$store.dispatch('getProvinces')
        this.$store.dispatch('getCities')
        this.$store.dispatch('getCouriers')
        this.$store.dispatch('getWarehouses')
    },
    beforeDestroy () {
        if (this.customerSearchTimeout) {
            clearTimeout(this.customerSearchTimeout);
        }

        if (this.vendorSearchTimeout) {
            clearTimeout(this.vendorSearchTimeout);
        }
    }
}
</script>

<style>

</style>
